import React from "react";
import { useHistory } from "react-router";
import { Spinner } from "@blueprintjs/core";
import { useAsyncEffect } from "@react-hook/async";

import { RobotsNoindex } from "@components";
import { useOrg } from "@hooks";

import { slackAppOAuth } from "@pages/settings/api";

export const SlackOAuthCallbackScreen: React.FC = () => {
  const history = useHistory();
  const org = useOrg();

  useAsyncEffect(async () => {
    const urlParams: URLSearchParams = new URLSearchParams(
      history.location.search
    );

    const handleCallback = async () => {
      const code: string | null = urlParams.get("code");
      const state: string | null = urlParams.get("state");

      if (!org) {
        throw new Error("No org found!");
      }

      if (!code) {
        // this means that the oauth was cancelled by the user
        history.push(`/orgs/${org.id}/settings/integrations`);
        return;
      }

      if (!state) {
        throw new Error(
          "No 'state' query parameter found in the Slack OAuth callback!"
        );
      }

      slackAppOAuth(org.id, code, state)
        .then((_) => {
          history.push(`/orgs/${org.id}/settings/integrations`);
        })
        .catch((err) => {
          if (err.statusCode === 404) {
            // Ignore NotFound to avoid flickering error screen
            return;
          }
          history.push(
            `/oauth/slack-error?deployment_id=${org.id}&error=${err?.body.error}`
          );
        });
    };
    await handleCallback();

    // await handleCallback();
  }, [org]); // Important: This must be empty so that callback runs ONLY once

  return (
    <div className="splash-screen">
      <RobotsNoindex />
      <Spinner intent="primary" />
      <div className="loading-text">Logging in...</div>
    </div>
  );
};
